import type { IntlShape } from 'react-intl';

export const ALLOWED_FILE_EXTENSIONS = [
  '.xls',
  '.xlsx',
  '.doc',
  '.docx',
  '.pdf',
  '.ppt',
  '.jpg',
  '.png',
  '.bmp',
  '.csv',
];

export const ALLOWED_FILE_EXTENSIONS_WIND = ['.xlsx'];

export function getFileFormatsMessageFromAllowedExtensions(
  allowedExtensions: string[],
  intl: IntlShape
): string {
  let fileFormats;
  if (allowedExtensions.length === 1) {
    [fileFormats] = allowedExtensions;
  } else {
    const fileFormats1 = allowedExtensions
      .slice(0, allowedExtensions.length - 2)
      .join(', ');
    const and = intl.formatMessage({ id: 'offerWizard.fileUpload.info1.and' });
    const fileFormats2 = allowedExtensions[allowedExtensions.length - 1];
    fileFormats = `${fileFormats1} ${and} ${fileFormats2}`;
  }
  return fileFormats;
}
